angular.module('ui.order.orderItemCard.orderItemCardDataProvider', [])

    .service('orderItemCardDataProvider', function (gettextCatalog, $q, $log, toastr, batching,
                                                    ordersRepository, orderItemsRepository, workflowRepository, categoryTypesRepository, categoriesRepository) {
        // Subscribers of Observer pattern
        // We use observers cause Angular doesn't track changes of $scope from 3rd party
        var subscribers = {};

        var orderItemId;
        var orderItem;
        var step;
        var order;

        var orderItemCategories;
        var orderItemWorkflowAudit;
        var categoryTypes;
        var categories;

        var _this = this;

        _.extend(_this, {
            // observer pattern subscription method
            onDataChange: onDataChange,

            //actions
            executeAction: executeAction,

            saveOrderItem: saveOrderItem,

            // setters
            setOrderItemId: setOrderItemId,

            // getters
            getOrderItemId: getOrderItemId,
            getOrderItem: getOrderItem,
            getStep: getStep,
            getOrder: getOrder,
            getOrderItemCategories: getOrderItemCategories,
            getOrderItemWorkflowAudit: getOrderItemWorkflowAudit,
            getCategoryTypes: getCategoryTypes,
            getCategories: getCategories
        });

        return _this;

        /**
         * Init all data for orderItem
         */
        function initOrderItem() {
            if (!orderItemId) {
                dropData();
                dataWasChanged();
                return;
            }

            var getOrderItemPromise = orderItemsRepository.getOrderItem(orderItemId)
                .then(
                    function (_orderItem) {
                        orderItem = _orderItem;
                        order = orderItem.$model.order;
                        step = orderItem.$model.stepCode;
                        return ordersRepository.getOrder(orderItem.$model.orderId);
                    },
                    function (error) {
                        $log.error("Can't load order item: " + error.message);
                        toastr.error(error.message, gettextCatalog.getString("Can't load order item"));
                        return $q.reject(null);
                    });

            var getCategoriesPromise = $q.all([
                orderItemsRepository.getCategoriesForOrderItem(orderItemId),
                categoryTypesRepository.getCategoryTypes()
            ])
                .then(
                    function (data) {
                        //save all existing on server category types
                        //and all categories linked to the order item
                        orderItemCategories = data[0];
                        categoryTypes = data[1];
                        //return promise that will get all the categories for each type
                        //marking the categories that already linked to specified order item
                        return categoriesRepository
                            .getCategoriesByTypeCodes(_.pluck(categoryTypes, '$model.code'))
                            .then(function (categories) {
                                //mark each category as linked if it exists in the list of linked to order item categories
                                _.each(categories, function (c) {
                                    c.isLinked = _.any(orderItemCategories, function (oic) {
                                        return oic.$model.id == c.$model.id;
                                    });
                                });
                                return categories;
                            });
                    })
                .then(
                    function (_categories) {
                        categories = _categories;
                    },
                    function (error) {
                        $log.error("Can't initialize categories: " + error.message);
                        toastr.error(error.message, gettextCatalog.getString("Can't initialize categories"));
                        return $q.reject(null);
                    });

            var getOrderItemWorkflowAudiPromise = orderItemsRepository.getWorkflowAudit(orderItemId)
                .then(
                    function(_orderItemWorkflowAudit) {
                        orderItemWorkflowAudit = _orderItemWorkflowAudit;
                    },
                    function (error) {
                        $log.error("Can't fetch orderItem workflow audit from server: " + error.message);
                        toastr.error(error.message, gettextCatalog.getString("Can't get Order Item workflow audit."));
                        return $q.reject(null);
                    }
                );

            $q.all(
                [
                    getOrderItemPromise,
                    getCategoriesPromise,
                    getOrderItemWorkflowAudiPromise
                ])
                .then(
                    function () {
                        dataWasChanged();
                    },
                    function () {
                        dataWasChanged();
                    });
        }

        function dropData() {
            orderItemId = null;
            orderItem = null;
            step = null;
            order = null;
            categories = null;
            orderItemCategories = null;
            orderItemWorkflowAudit = null;
        }

        function saveOrderItem() {
            var orderToSave = order;
            var orderItemToSave = orderItem;

            if (!orderToSave || !orderItemToSave) {
                return $q.reject(null);
            }
            
            // Promises
            var saveOrderItemPromise = function () {
                return orderItemsRepository.saveOrderItem(orderItemToSave)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = (error.serverErrorMessage && _.str.startsWith(error.serverErrorMessage, "Can not use EditOrderItem to change step."))
                                ? gettextCatalog.getString("Item was updated on server. Please, review it before saving any changes.")
                                : error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Order item save failed"));
                            $log.error("OrderItem saving error: unable to save OrderItem. \n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            var saveOrderPromise = function () {
                return ordersRepository.saveOrder(orderToSave)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Order save failed"));
                            $log.error("OrderItem saving error: unable to save Order. \n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            return $q.all([
                saveOrderItemPromise(),
                saveOrderPromise()
            ]);
        }

        function executeAction(actionCode, unlinkedCategories, linkedCategories) {
            // processing categories:
            // we need to loop through existing order item categories to see if anyone was unlinked
            // and through other categories to see if anyone was linked instead
            var toUnlink = _.filter(orderItemCategories, function (existingOrderItemCategory) {
                return _.any(unlinkedCategories, function (c) {
                    return c.$model.id == existingOrderItemCategory.$model.id;
                });
            });
            var toLink = _.filter(linkedCategories, function (categoryToLink) {
                return !_.any(orderItemCategories, function (c) {
                    return c.$model.id == categoryToLink.$model.id;
                });
            });

            // Copy all needed resources
            var actionCodeToSave = _.clone(actionCode);
            var stepCodeToSave = _.clone(step);
            var orderToSave = order;
            var orderItemToSave = orderItem;
            var orderItemIdToSave = orderItem.getId();
            var categoriesToLink = _.pluck(toLink, "$model.id");
            var categoriesToUnlink = _.pluck(toUnlink, "$model.id");

            // Promises

            var saveOrderItemPromise = function () {
                return orderItemsRepository.saveOrderItem(orderItemToSave)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = (error.serverErrorMessage && _.str.startsWith(error.serverErrorMessage, "Can not use EditOrderItem to change step."))
                                ? gettextCatalog.getString("Item was updated on server. Please, review it before saving any changes.")
                                : error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Order item save failed"));
                            $log.error("Action executing error: unable to save OrderItem. \n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            var saveOrderPromise = function () {
                return ordersRepository.saveOrder(orderToSave)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Order save failed"));
                            $log.error("Action executing error: unable to save Order. \n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            var actionExecutePromise = function () {
                return workflowRepository.executeActionForOrderItem(stepCodeToSave, actionCodeToSave, orderItemIdToSave)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Action can not be executed"));
                            $log.error("Action executing error: \n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            var unlinkCategoriesPromise = function () {
                return orderItemsRepository
                    .unlinkCategoriesFromOrderItem(orderItemIdToSave, categoriesToUnlink)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Unable to unlink Order Item categories"));
                            $log.error("Action executing error: unable to unlink Order Item categories\n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            var linkCategoriesPromise = function () {
                return orderItemsRepository
                    .linkCategoriesToOrderItem(orderItemIdToSave, categoriesToLink)
                    .then(function (resp) {
                        return resp;
                    }, function (error) {
                        if (error) {
                            var em = error.serverErrorMessage || error.message;
                            toastr.error(em, gettextCatalog.getString("Unable to link Order Item categories"));
                            $log.error("Action executing error: unable to link Order Item categories\n" + error.message);
                        }
                        return $q.reject(null);
                    });
            };

            if (batching.isEnabled()) {

                return $q.all([
                    saveOrderItemPromise(),
                    saveOrderPromise()
                ])
                    .then(function () {
                        batching.forceStartBatch(3, true);
                        return $q.all([
                            actionExecutePromise(),
                            unlinkCategoriesPromise(),
                            linkCategoriesPromise()
                        ]);
                    });
            } else {

                return $q.all([
                    saveOrderItemPromise(),
                    saveOrderPromise()
                ])
                    .then(function () {
                        return actionExecutePromise();
                    })
                    .then(function () {
                        return unlinkCategoriesPromise();
                    })
                    .then(function () {
                        return linkCategoriesPromise();
                    });

            }
        }

        //region Observer pattern

        function onDataChange(subscriberName, cb) {
            subscribers[subscriberName] = cb;
        }

        function dataWasChanged() {
            _.forEach(subscribers, function (callback) {
                if (callback && _.isFunction(callback)) {
                    callback();
                }
            });
        }

        //endregion

        //region Setters

        /**
         * Set order item id
         * @param {string|number} [id] order item id
         */
        function setOrderItemId(id, force) {
            if (id !== orderItemId || force === true) {
                orderItemId = id;
                initOrderItem();
            }
        }

        //endregion

        //region Getters

        /**
         * Get orderItemId
         * @returns {string|number}
         */
        function getOrderItemId() {
            return orderItemId;
        }

        /**
         * Get orderItem
         * @returns {RepresentationModel}
         */
        function getOrderItem() {
            return orderItem;
        }

        /**
         * Get step
         * @returns {string}
         */
        function getStep() {
            return step;
        }

        /**
         * Get order
         * @returns {RepresentationModel}
         */
        function getOrder() {
            return order;
        }

        /**
         * Get order item categories
         * @returns {RepresentationModel[]}
         */
        function getOrderItemCategories() {
            return orderItemCategories;
        }

        /**
         * Get order item workflow audit records
         * @returns {RepresentationModel[]}
         */
        function getOrderItemWorkflowAudit() {
            return orderItemWorkflowAudit;
        }

        /**
         *
         * @returns {RepresentationModel[]}
         */
        function getCategoryTypes() {
            return categoryTypes;
        }

        /**
         * Get categories
         * @returns {RepresentationModel[]}
         */
        function getCategories() {
            return categories;
        }

        //endregion
    })

;
